import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { formatDate } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  ButtonGroup,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  TextField,
  Paper,
  Pagination,
  FormControlLabel,
  Checkbox,
  DialogContent,
} from "@mui/material";
import DatePicker from "react-datepicker";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchIcon from "@mui/icons-material/Search";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahReturPembelian = () => {
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [openUbah, setOpenUbah] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isReturPembelianSaved, setIsReturPembelianSaved] = useState(false);
  const [isInputStok, setIsInputStok] = useState(false);
  const [returPembelianId, setReturPembelianId] = useState(null);

  // Data Retur Pembelian
  const [noNotaReturPembelian, setNoNotaReturPembelian] = useState("");
  let tempTglReturPembelian = new Date();
  if (tempTglReturPembelian > new Date(user.tutupperiode.sampaiTanggal)) {
    tempTglReturPembelian = new Date(user.tutupperiode.dariTanggal);
  }
  const [tglReturPembelian, setTglReturPembelian] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [jumlahItem, setJumlahItem] = useState("0");

  // Data Supplier
  const [supplierId, setSupplierId] = useState("");
  const [kodeSupplier, setKodeSupplier] = useState("");
  const [namaSupplier, setNamaSupplier] = useState("");
  const [alamatSupplier, setAlamatSupplier] = useState("");
  const [noNotaPembelian, setNoNotaPembelian] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");

  // Data Total
  const [subtotal, setSubtotal] = useState("0");
  const [potongan, setPotongan] = useState("0");
  const [isPpn, setIsPpn] = useState(false);
  const [ppnPersen, setPpnPersen] = useState("0");
  const [ppnTotal, setPpnTotal] = useState("0");
  const [total, setTotal] = useState("0");

  // Data Retur Pembelian Kredit
  const [tipeReturPembelian, setTipeReturPembelian] = useState("TUNAI");

  // Data Retur Pembelian Child
  const [idReturPembelianChild, setIdReturPembelianChild] = useState("");
  const [pilihStok, setPilihStok] = useState("");
  const [kodeStok, setKodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [quantity, setQuantity] = useState("0");
  const [hargaSatuan, setHargaSatuan] = useState("0");
  const [discountPersen1, setDiscountPersen1] = useState("0");
  const [discount1, setDiscount1] = useState("0");
  const [hargaNetto, setHargaNetto] = useState("0");
  const [totalReturPembelianChild, setTotalReturPembelianChild] = useState("0");

  const [returPembelianChilds, setReturPembelianChilds] = useState([]);

  const [coas, setCoas] = useState([]);
  const [error, setError] = useState(false);

  const [suppliers, setSuppliers] = useState([]);
  const [searchTermSupplier, setSearchTermSupplier] = useState("");
  const [openSupplier, setOpenSupplier] = useState(false);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [pembelians, setPembelians] = useState([]);
  const [searchTermPembelian, setSearchTermPembelian] = useState("");
  const [openPembelian, setOpenPembelian] = useState(false);
  let [pagePembelian, setPagePembelian] = useState(0);
  const [limitPembelian, setLimitPembelian] = useState(10);
  const [pagesPembelian, setPagesPembelian] = useState(0);
  const [rowsPembelian, setRowsPembelian] = useState(0);
  const [queryPembelian, setQueryPembelian] = useState("");

  const [stoks, setStoks] = useState([]);
  const [searchTermStok, setSearchTermStok] = useState("");
  const [openStok, setOpenStok] = useState(false);

  let [pageStok, setPageStok] = useState(0);
  const [limitStok, setLimitStok] = useState(10);
  const [pagesStok, setPagesStok] = useState(0);
  const [rowsStok, setRowsStok] = useState(0);
  const [queryStok, setQueryStok] = useState("");

  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermSupplier(query);
  };

  const handleClickOpenUbah = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenUbah(true);
  };

  const handleCloseUbah = () => {
    setOpenUbah(false);
    setIdReturPembelianChild("");
    setKodeStok("");
    setNamaStok("");
    setQuantity("");
    setHargaSatuan("");
    setDiscountPersen1("");
    setDiscount1("");
    setHargaNetto("");
    setTotalReturPembelianChild("");
  };

  const handleClickOpenSupplier = () => {
    setOpenSupplier(true);
  };

  const handleCloseSupplier = () => {
    setOpenSupplier(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChangePembelian = (e, p) => {
    setPagePembelian(p - 1);
  };

  const searchDataPembelian = (e) => {
    e.preventDefault();
    setPagePembelian(0);
    setSearchTermPembelian(queryPembelian);
  };

  const handleClickOpenPembelian = () => {
    setOpenPembelian(true);
  };

  const handleClosePembelian = () => {
    setOpenPembelian(false);
  };

  const handleChangeStok = (e, p) => {
    setPageStok(p - 1);
  };

  const searchDataStok = (e) => {
    e.preventDefault();
    setPageStok(0);
    setSearchTermStok(queryStok);
  };

  const handleClickOpenStok = () => {
    setOpenStok(true);
  };

  const handleCloseStok = () => {
    setOpenStok(false);
  };

  const tipeReturPembelianOption = ["TUNAI", "KREDIT"];
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));

  useEffect(() => {
    getNextKodeReturPembelian(tempTglReturPembelian);
    getReturPembelianById();
    getCoas();
    findDefaultDate();
  }, []);

  useEffect(() => {
    getSuppliersData();
  }, [page, searchTermSupplier]);

  useEffect(() => {
    getPembeliansData();
  }, [supplierId, page, searchTermPembelian]);

  useEffect(() => {
    getStoksData();
  }, [pageStok, searchTermStok]);

  const getNextKodeReturPembelian = async (date) => {
    const nextKodeReturPembelian = await axios.post(
      `${tempUrl}/returPembeliansNextKode`,
      {
        dariTanggal: user.tutupperiode.dariTanggal,
        sampaiTanggal: user.tutupperiode.sampaiTanggal,
        tglReturPembelian: date,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setNoNotaReturPembelian(nextKodeReturPembelian.data);
  };

  const getReturPembelianById = async () => {
    if (id) {
      setIsReturPembelianSaved(true);
      setIsInputStok(true);
      setReturPembelianId(id);
      const response = await axios.post(`${tempUrl}/returPembelians/${id}`, {
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      });
      // Data Retur Pembelian
      setNoNotaReturPembelian(response.data.noNotaReturPembelian);
      setTglReturPembelian(new Date(response.data.tglReturPembelian));

      // Data Supplier
      setKodeSupplier(response.data.supplier.kodeSupplier);
      setNamaSupplier(response.data.supplier.namaSupplier);
      setAlamatSupplier(response.data.supplier.alamatSupplier);
      setKodeCOA(
        response.data.coa &&
          `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`
      );

      // Data Total
      setSubtotal(response.data.subtotal);
      setPotongan(response.data.potongan);
      setTotal(response.data.total);
      setPpnTotal(response.data.ppnTotal);

      // Data Retur Pembelian Kredit
      setTipeReturPembelian(response.data.tipeReturPembelian);

      const response2 = await axios.post(
        `${tempUrl}/returPembelianChildsByReturPembelian`,
        {
          returPembelianId: response.data.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        }
      );
      setReturPembelianChilds(response2.data);
      setJumlahItem(response2.data.length);
    }
  };

  const getCoas = async () => {
    const response = await axios.post(`${tempUrl}/coas`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCoas(response.data);
  };

  const findDefaultDate = async () => {
    let newPeriodeAwal = new Date(user.tutupperiode.dariTanggal);
    let newPeriodeAkhir = new Date(user.tutupperiode.sampaiTanggal);
    let newToday = new Date();

    let isDateBetween =
      newToday >= newPeriodeAwal && newToday <= newPeriodeAkhir;

    if (isDateBetween) {
      // Default Date Today
      setTglReturPembelian(new Date());
    }
  };

  const getSuppliersData = async () => {
    const response = await axios.post(
      `${tempUrl}/suppliersPagination?search_query=${searchTermSupplier}&page=${page}&limit=${limit}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setSuppliers(response.data.suppliers);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const getPembeliansData = async () => {
    const response = await axios.post(
      `${tempUrl}/pembeliansTipePembelianKreditPerSupplierPerCabangPagination?search_query=${searchTermPembelian}&page=${pagePembelian}&limit=${limitPembelian}`,
      {
        supplierId,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setPembelians(response.data.pembelians);
    setPagePembelian(response.data.page);
    setPagesPembelian(response.data.totalPage);
    setRowsPembelian(response.data.totalRows);
  };

  const getSupplierNextKode = async () => {
    const response = await axios.post(`${tempUrl}/supplierNextKode`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeSupplier(response.data);
  };

  const getStoksData = async () => {
    const response = await axios.post(
      `${tempUrl}/stoksPagination?search_query=${searchTermStok}&page=${pageStok}&limit=${limitStok}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setStoks(response.data.stoks);
    setPageStok(response.data.page);
    setPagesStok(response.data.totalPage);
    setRowsStok(response.data.totalRows);
  };

  const getFindStok = async (input) => {
    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeStok(response.data.kodeStok);
    setNamaStok(response.data.namaStok);
  };

  const saveReturPembelian = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (returPembelianId !== null) {
      setIsInputStok(true);
      setQuantity("0");
      setHargaSatuan("0");
      setDiscountPersen1("0");
      setDiscount1("0");
      setHargaNetto("0");
      setTotalReturPembelianChild("0");
      return;
    }

    let tempValidation = form.checkValidity() && kodeSupplier.length !== 0;
    if (tipeReturPembelian === "TUNAI") {
      tempValidation =
        form.checkValidity() &&
        kodeSupplier.length !== 0 &&
        kodeCOA.length !== 0;
    } else {
      tempValidation =
        form.checkValidity() &&
        kodeSupplier.length !== 0 &&
        noNotaPembelian.length !== 0;
    }

    if (tempValidation) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedReturPembelian = await axios.post(
          `${tempUrl}/saveReturPembelian`,
          {
            dariTanggal: user.tutupperiode.dariTanggal,
            sampaiTanggal: user.tutupperiode.sampaiTanggal,

            // Data Retur Pembelian
            noNotaReturPembelian,
            tglReturPembelian,

            // Data Supplier
            kodeSupplier,
            namaSupplier,
            alamatSupplier,
            noNotaPembelian,
            kodeCOA: kodeCOA.split(" ", 1)[0],

            // Total
            subtotal,
            potongan,
            total,
            ppnTotal,

            // Data Retur Pembelian Kredit
            tipeReturPembelian,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsReturPembelianSaved(true);
        setIsInputStok(true);
        // setLoading(false);
        setReturPembelianId(savedReturPembelian.data.id);
        navigate(
          `/daftarReturPembelian/returPembelian/tambahReturPembelian/${savedReturPembelian.data.id}`
        );
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const saveReturPembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedReturPembelianChild = await axios.post(
          `${tempUrl}/saveReturPembelianChild`,
          {
            // Data Retur Pembelian Child
            returPembelianId,
            kodeStok,
            namaStok,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            hargaNetto,
            totalReturPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Retur Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setHargaNetto("");
        setTotalReturPembelianChild("");

        let findReturPembelianChild = await axios.post(
          `${tempUrl}/returPembelianChildsByReturPembelian`,
          {
            returPembelianId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setReturPembelianChilds(findReturPembelianChild.data);
        setJumlahItem(findReturPembelianChild.data.length);

        let findReturPembelian = await axios.post(
          `${tempUrl}/returPembelians/${returPembelianId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSubtotal(findReturPembelian.data.subtotal);
        setTotal(findReturPembelian.data.subtotal);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const updateReturPembelianChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen1.length !== 0 &&
      discount1.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedReturPembelianChild = await axios.post(
          `${tempUrl}/updateReturPembelianChild/${idReturPembelianChild}`,
          {
            // Data Retur Pembelian Child
            returPembelianId,
            kodeStok,
            namaStok,
            quantity,
            hargaSatuan,
            discountPersen1,
            discount1,
            hargaNetto,
            totalReturPembelianChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Retur Pembelian Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantity("");
        setHargaSatuan("");
        setDiscountPersen1("");
        setDiscount1("");
        setHargaNetto("");
        setTotalReturPembelianChild("");

        let findReturPembelianChild = await axios.post(
          `${tempUrl}/returPembelianChildsByReturPembelian`,
          {
            returPembelianId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setReturPembelianChilds(findReturPembelianChild.data);
        setJumlahItem(findReturPembelianChild.data.length);

        let findReturPembelian = await axios.post(
          `${tempUrl}/returPembelians/${returPembelianId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSubtotal(findReturPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findReturPembelian.data.subtotal);

        handleCloseUbah();
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const deleteReturPembelianChild = async (e, id, totalReturPembelianChild) => {
    e.preventDefault();
    e.stopPropagation();

    const confirmed = window.confirm("Yakin ingin menghapus barang ini?");
    if (!confirmed) return;

    const form = e.currentTarget;
    if (form.checkValidity()) {
      // setLoading(true);
      try {
        // setLoading(true);
        let deletedReturPembelianChild = await axios.post(
          `${tempUrl}/deleteReturPembelianChild/${id}`,
          {
            // Data Retur Pembelian Child
            returPembelianId,
            totalReturPembelianChild,

            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        let findReturPembelianChild = await axios.post(
          `${tempUrl}/returPembelianChildsByReturPembelian`,
          {
            returPembelianId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setReturPembelianChilds(findReturPembelianChild.data);
        setJumlahItem(findReturPembelianChild.data.length);

        let findReturPembelian = await axios.post(
          `${tempUrl}/returPembelians/${returPembelianId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSubtotal(findReturPembelian.data.subtotal);
        setPotongan("0");
        setPpnPersen("0");
        setPpnTotal("0");
        setTotal(findReturPembelian.data.subtotal);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const saveReturPembelianTotal = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let tempValidation = form.checkValidity();

    if (tipeReturPembelian === "KREDIT") {
      tempValidation = form.checkValidity();
    }

    if (tempValidation) {
      // setLoading(true);
      try {
        // setLoading(true);
        let updatedReturPembelian = await axios.post(
          `${tempUrl}/updateReturPembelianTotal/${returPembelianId}`,
          {
            tglReturPembelian,
            // Total
            subtotal,
            potongan,
            total,
            ppnPersen,
            ppnTotal,

            // Data Retur Pembelian Kredit
            tipeReturPembelian,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        navigate(`/daftarReturPembelian`);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Retur Pembelian</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveReturPembelian}>
        <Card>
          <Card.Header>Data Retur Pembelian</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Retur :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noNotaReturPembelian} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal{" "}
                        {isReturPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglReturPembelian}
                          minDate={new Date(user.tutupperiode.dariTanggal)}
                          maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglReturPembelian(date);
                            getNextKodeReturPembelian(date);
                          }}
                          disabled={isReturPembelianSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jumlahItem}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Supplier</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode Supplier{" "}
                        {isReturPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          value={kodeSupplier}
                          style={{ textTransform: "uppercase" }}
                          disabled
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenSupplier()}
                          disabled={isReturPembelianSaved && true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={namaSupplier}
                          style={{ textTransform: "uppercase" }}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={alamatSupplier}
                          style={{ textTransform: "uppercase" }}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe{" "}
                        {isReturPembelianSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={tipeReturPembelian}
                          onChange={(e) => {
                            setTipeReturPembelian(e.target.value);

                            if (e.target.value === "TUNAI") {
                            } else {
                              setKodeCOA("");
                            }
                            setNoNotaPembelian("");
                          }}
                          disabled={isReturPembelianSaved && true}
                        >
                          {tipeReturPembelianOption.map(
                            (tipeReturPembelian) => (
                              <option value={tipeReturPembelian}>
                                {tipeReturPembelian}
                              </option>
                            )
                          )}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota Pembelian{" "}
                        {isReturPembelianSaved === false &&
                        tipeReturPembelian === "KREDIT" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          value={noNotaPembelian}
                          style={{ textTransform: "uppercase" }}
                          disabled
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenPembelian()}
                          disabled={
                            isReturPembelianSaved ||
                            (tipeReturPembelian !== "KREDIT" && true)
                          }
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode Kas{" "}
                        {isReturPembelianSaved === false &&
                        tipeReturPembelian === "TUNAI" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={coaOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeCOA.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeCOA(value.label);
                            } else {
                              setKodeCOA("");
                            }
                          }}
                          value={kodeCOA}
                          disabled={
                            isReturPembelianSaved ||
                            (tipeReturPembelian === "KREDIT" && true)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Catatan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={keterangan}
                          onChange={(e) => {
                            setKeterangan(e.target.value);
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isReturPembelianSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="contained"
            color="info"
            sx={{
              bgcolor: "info.light",
              textTransform: "none",
              marginRight: 2,
              marginBottom: 2,
            }}
            type="submit"
          >
            {"+ Input Transaksi"}
          </Button>
        </Box>
      </Form>

      <Form noValidate validated={validated} onSubmit={saveReturPembelianChild}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode / Barcode{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={pilihStok}
                          onChange={(e) => {
                            setPilihStok(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              // alert("Enter pressed on kodeStok");
                              getFindStok(e.target.value);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenStok()}
                          disabled={isInputStok === true ? false : true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Stok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaStok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Quantity{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={quantity}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setQuantity(tempValue);

                            let tempHargaNetto =
                              parseFloat(hargaSatuan) - parseFloat(discount1);
                            setHargaNetto(tempHargaNetto);

                            let tempTotalReturPembelianChild =
                              parseFloat(tempValue) *
                              parseFloat(tempHargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild
                            );
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Satuan{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={hargaSatuan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setHargaSatuan(tempValue);

                            let tempHargaNetto =
                              parseFloat(tempValue) - parseFloat(discount1);
                            setHargaNetto(tempHargaNetto);

                            let tempTotalReturPembelianChild =
                              parseFloat(quantity) * parseFloat(tempHargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild
                            );

                            let tempDiscount1 =
                              (parseFloat(tempValue) * discountPersen1) / 100;
                            setDiscount1(tempDiscount1);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc / Pot. 1{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;

                            let tempValue = values.formattedValue;
                            setDiscountPersen1(tempValue);

                            let tempDiscount1 =
                              (parseFloat(hargaSatuan) * tempValue) / 100;
                            setDiscount1(tempDiscount1);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) -
                              parseFloat(tempDiscount1);
                            setHargaNetto(temHargaNetto);

                            let tempTotalReturPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild
                            );
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount1}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setDiscount1(tempValue);

                            let tempDiscountPersen1 =
                              (parseFloat(tempValue) /
                                parseFloat(hargaSatuan)) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen1 = Number(
                              tempDiscountPersen1.toFixed(2)
                            );
                            setDiscountPersen1(tempDiscountPersen1);

                            let temHargaNetto =
                              parseFloat(hargaSatuan) - parseFloat(tempValue);
                            setHargaNetto(temHargaNetto);

                            let tempTotalReturPembelianChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalReturPembelianChild(
                              tempTotalReturPembelianChild
                            );
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Netto :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={hargaNetto}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalReturPembelianChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
                disabled={isInputStok === true ? false : true}
              >
                Simpan Transaksi
              </Button>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table aria-label="simple table">
            <TableHead className={classes.root}>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Kode
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Nama Stok
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Qty.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Sat.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Harga
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  D1 (%)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Pot1 (Rp)
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Total Rp.
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableRightBorder}
                >
                  Aksi
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {returPembelianChilds.map((user, index) => (
                <TableRow
                  key={user.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    "&:hover": { bgcolor: Colors.grey300 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {user.stok.kodeStok}
                  </TableCell>
                  <TableCell>{user.stok.namaStok}</TableCell>
                  <TableCell align="right">
                    {user.quantity.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>{user.stok.satuanKecilStok}</TableCell>
                  <TableCell align="right">
                    {user.hargaNetto.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discountPersen1.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.discount1.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell align="right">
                    {user.totalReturPembelianChild.toLocaleString("de-DE")}
                  </TableCell>
                  <TableCell>
                    <ButtonGroup variant="contained">
                      <Button
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          handleClickOpenUbah(e);
                          setIdReturPembelianChild(user.id);
                          setKodeStok(user.stok.kodeStok);
                          setNamaStok(user.stok.namaStok);
                          setQuantity(user.quantity);
                          setHargaSatuan(user.hargaSatuan);
                          setDiscountPersen1(user.discountPersen1);
                          setDiscount1(user.discount1);
                          setHargaNetto(user.hargaNetto);
                          setTotalReturPembelianChild(
                            user.totalReturPembelianChild
                          );
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        color="error"
                        sx={{ textTransform: "none" }}
                        onClick={(e) => {
                          deleteReturPembelianChild(
                            e,
                            user.id,
                            user.totalReturPembelianChild
                          );
                        }}
                      >
                        <DeleteOutlineIcon />
                      </Button>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Form noValidate validated={validated} onSubmit={saveReturPembelianTotal}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Total</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Subtotal :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={subtotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Potongan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={potongan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setPotongan(tempValue);

                            let tempPpnTotal = 0;

                            if (isPpn) {
                              tempPpnTotal =
                                ((parseFloat(subtotal) -
                                  parseFloat(tempValue)) *
                                  parseFloat(ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);
                            } else {
                              setPpnTotal(tempPpnTotal);
                            }

                            let tempTotal =
                              parseFloat(subtotal) -
                              parseFloat(tempValue) -
                              parseFloat(tempPpnTotal);
                            setTotal(tempTotal);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        PPN ({setting.ppnPersen}) <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="2">
                        <FormControlLabel
                          control={<Checkbox checked={isPpn} />}
                          onChange={() => {
                            setIsPpn(!isPpn);

                            if (!isPpn) {
                              setPpnPersen(setting.ppnPersen);
                              let tempPpnTotal =
                                ((parseFloat(subtotal) - parseFloat(potongan)) *
                                  parseFloat(setting.ppnPersen)) /
                                100;
                              setPpnTotal(tempPpnTotal);

                              let tempTotal =
                                parseFloat(subtotal) -
                                parseFloat(potongan) -
                                parseFloat(tempPpnTotal);
                              setTotal(tempTotal);
                            } else {
                              setPpnPersen(0);
                              setPpnTotal(0);

                              let tempTotal =
                                parseFloat(subtotal) - parseFloat(potongan);
                              setTotal(tempTotal);
                            }
                          }}
                        />
                      </Col>
                      <Col sm="5">
                        <NumericFormat
                          value={ppnTotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={total}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarReturPembelian")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            type="submit"
            disabled={returPembelianId === null && true}
          >
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}

      <Dialog
        open={openSupplier}
        onClose={handleCloseSupplier}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Supplier`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Alamat
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {suppliers.map((supplier, index) => (
                    <TableRow
                      key={supplier._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setSupplierId(supplier.id);
                        setKodeSupplier(supplier.kodeSupplier);
                        setNamaSupplier(supplier.namaSupplier);
                        setAlamatSupplier(supplier.alamatSupplier);
                        setNoNotaPembelian("");

                        handleCloseSupplier();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {supplier.kodeSupplier}
                      </TableCell>
                      <TableCell>{supplier.namaSupplier}</TableCell>
                      <TableCell>{supplier.alamatSupplier}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openPembelian}
        onClose={handleClosePembelian}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Pembelian`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataPembelian}>
              <Box sx={searchBarContainer}>
                <SearchBar
                  value={queryPembelian}
                  setSearchTerm={setQueryPembelian}
                />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No. Nota
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Tgl.
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Saldo Hutang
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pembelians.map((pembelian, index) => (
                    <TableRow
                      key={pembelian._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setNoNotaPembelian(pembelian.noNotaPembelian);

                        handleClosePembelian();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {pembelian.noNotaPembelian}
                      </TableCell>
                      <TableCell>
                        {formatDate(pembelian.tglPembelian)}
                      </TableCell>
                      <TableCell>
                        {(
                          pembelian.total - pembelian.totalBayar
                        ).toLocaleString("de-DE")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesPembelian}
                page={pagePembelian + 1}
                onChange={handleChangePembelian}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openStok}
        onClose={handleCloseStok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Stok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataStok}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryStok} setSearchTerm={setQueryStok} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Satuan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                    >
                      Sisa
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoks.map((stok, index) => (
                    <TableRow
                      key={stok._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setPilihStok(stok.kodeStok);
                        setKodeStok(stok.kodeStok);
                        setNamaStok(stok.namaStok);
                        setQuantity("0");
                        setHargaSatuan("0");
                        setDiscountPersen1("0");
                        setDiscount1("0");
                        setHargaNetto("0");
                        setTotalReturPembelianChild("0");

                        handleCloseStok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {stok.kodeStok}
                      </TableCell>
                      <TableCell>{stok.namaStok}</TableCell>
                      <TableCell>{stok.satuanKecilStok}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesStok}
                page={pageStok + 1}
                onChange={handleChangeStok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        onClose={handleCloseUbah}
        aria-labelledby="customized-dialog-title"
        open={openUbah}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Ubah Barang Retur Pembelian
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseUbah}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          dividers
          //  sx={{ height: "200px" }}
        >
          <div>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Kode / Barcode :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={pilihStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Nama Stok :
                  </Form.Label>
                  <Col sm="7">
                    <Form.Control disabled value={namaStok} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Quantity <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={quantity}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setQuantity(tempValue);

                        let tempHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(discount1);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(tempValue) * parseFloat(tempHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Satuan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      required
                      value={hargaSatuan}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setHargaSatuan(tempValue);

                        let tempHargaNetto =
                          parseFloat(tempValue) - parseFloat(discount1);
                        setHargaNetto(tempHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(quantity) * parseFloat(tempHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild
                        );

                        let tempDiscount1 =
                          (parseFloat(tempValue) * discountPersen1) / 100;
                        setDiscount1(tempDiscount1);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Disc / Pot. 1 <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="3">
                    <NumericFormat
                      required
                      value={discountPersen1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;

                        let tempValue = values.formattedValue;
                        setDiscountPersen1(tempValue);

                        let tempDiscount1 =
                          (parseFloat(hargaSatuan) * tempValue) / 100;
                        setDiscount1(tempDiscount1);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(tempDiscount1);
                        setHargaNetto(temHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild
                        );
                      }}
                    />
                  </Col>
                  <Col sm="4">
                    <NumericFormat
                      required
                      value={discount1}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values, sourceInfo) => {
                        if (sourceInfo.source !== "event") return;
                        let tempValue = values.formattedValue
                          .split(".")
                          .join("")
                          .replace(/,/g, "");
                        setDiscount1(tempValue);

                        let tempDiscountPersen1 =
                          (parseFloat(tempValue) / parseFloat(hargaSatuan)) *
                          100;
                        // limit to 2 decimals
                        tempDiscountPersen1 = Number(
                          tempDiscountPersen1.toFixed(2)
                        );
                        setDiscountPersen1(tempDiscountPersen1);

                        let temHargaNetto =
                          parseFloat(hargaSatuan) - parseFloat(tempValue);
                        setHargaNetto(temHargaNetto);

                        let tempTotalReturPembelianChild =
                          parseFloat(quantity) * parseFloat(temHargaNetto);
                        setTotalReturPembelianChild(
                          tempTotalReturPembelianChild
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Harga Netto :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={hargaNetto}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="5" style={textRight}>
                    Total :
                  </Form.Label>
                  <Col sm="7">
                    <NumericFormat
                      disabled
                      value={totalReturPembelianChild}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={updateReturPembelianChild}
          >
            Simpan
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahReturPembelian;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};
